export const UF = 'uf';
export const MUNICIPIO = 'municipio';
export const INSTITUICAO = 'instituicao';
export const REDE = 'rede';
export const FUNCIONARIO_ENVIO = 'funcionario-envio';
export const REQUISICAO = 'requisicao';
export const NOME_PACIENTE = 'paciente';
export const DATA_EXAME_DE = 'data-exame-de';
export const DATA_EXAME_ATE = 'data-exame-ate';
export const DATA_LAUDO_DE = 'data-laudo-de';
export const DATA_LAUDO_ATE = 'data-laudo-ate';
export const DATA_INVALIDACAO_DE = 'data-invalidacao-de';
export const DATA_INVALIDACAO_ATE = 'data-invalidacao-ate';
export const SITUACAO_EXAME_LAUDO = 'situacao-laudo';
export const SEM_LAUDO_72H = 'atrasado';
export const SITUACAO_EXAME = 'situacao';
export const PROTOCOLO = 'protocolo';
export const NUMERO_EXAME = 'numero-exame';
export const CPF_PACIENTE = 'cpf-paciente';
export const CNS_PACIENTE = 'cns-paciente';
export const MEDICO_EXECUTOR = 'medico-executor';
export const EXAME_PRIORIZADO = 'exame-priorizado';

export const SECOES = {
    DADOS_DO_PACIENTE: 'dadosDoPaciente',
    DADOS_DO_EXAME: 'dadosDoExame',
    OUTRAS_INFORMACOES: 'outrasInformacoes',
    LAUDO: 'laudo',
    INVALIDO: 'invalido',
    IMAGENS: 'imagens',
};

/** Chaves exclusivas usadas como `key` em elementos React */
export const REACT_KEYS = {
    BTN_IMPRIMIR: 'btn-imprimir',
    BTN_PROTOCOLO: 'btn-protocolo',
    BTN_TERMO: 'btn-termo',
    BTN_PRIORIZAR: 'btn-priorizar',
    BTN_INVALIDAR: 'btn-invalidar',
    SEC_DADOS_DO_PACIENTE: 'sec-dados-do-paciente',
    SEC_DADOS_DO_EXAME: 'sec-dados-do-exame',
    SEC_OUTRAS_INFORMACOES: 'sec-outras-informacoes',
    SEC_LAUDO: 'sec-laudo',
    SEC_INVALIDO: 'sec-invalido',
    SEC_IMAGENS: 'sec-imagens',
};
